module.exports = __webpack_public_path__ + "static/media/Bishop Letter.e98ea11e.pdf";